import { TopicType, TopicTypes } from './constants'
import {
  Add,
  GridView,
  Sort,
  FilterList,
  Folder,
  Explore,
  MoreVert,
  TrendingUp,
  Schedule,
  Pattern,
  PhotoLibrary,
  Search,
  Check,
  CalendarToday,
  SortByAlpha,
  Category,
  ViewList,
  Close,
  Rocket,
  AutoAwesome,
  GridViewRounded,
  AutoAwesomeOutlined,
  AutoAwesomeRounded,
  FolderOutlined,
  FolderRounded,
  HandymanOutlined,
  HandymanRounded,
  PushPinOutlined,
  PushPinRounded,
} from '@mui/icons-material'

export const WORK_IN_PROGRESS_TYPE = 4001
export const BASE_TABS = [
  {
    id: TopicTypes[TopicType.ALL].key,
    label: TopicTypes[TopicType.ALL].tabTitle,
    value: TopicType.ALL,
    defaultIcon: <GridView />,
    activeIcon: <GridViewRounded />,
  },
  {
    id: TopicTypes[TopicType.PATTERN].key,
    label: TopicTypes[TopicType.PATTERN].tabTitle,
    value: TopicType.PATTERN,
    defaultIcon: <AutoAwesomeOutlined />,
    activeIcon: <AutoAwesomeRounded />,
  },
  {
    id: TopicTypes[TopicType.ALBUM].key,
    label: TopicTypes[TopicType.ALBUM].tabTitle,
    value: TopicType.ALBUM,
    defaultIcon: <FolderOutlined />,
    activeIcon: <FolderRounded />,
  },
  {
    id: TopicTypes[TopicType.PIN_COLLECTION].key,
    label: TopicTypes[TopicType.PIN_COLLECTION].tabTitle,
    value: TopicType.PIN_COLLECTION,
    defaultIcon: <PushPinOutlined />,
    activeIcon: <PushPinRounded />,
  },
]

export const DISCOVER_TABS = [...BASE_TABS]
export const WORKSPACE_TABS = [
  ...BASE_TABS,
  {
    id: 'wip',
    label: 'WIP',
    value: WORK_IN_PROGRESS_TYPE,
    defaultIcon: <HandymanOutlined />,
    activeIcon: <HandymanRounded />,
  },
]
